import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useUser } from "../../Context/UserContext";
import companyData from "../../Data/CompanyData";
import { Card, CardContent } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";

const CompanyProfileHeader = ({ companyDataProfile }) => {
  const { company, profile } = companyDataProfile;
  const { companyId } = useParams();
  const { user } = useUser();
  const navigate = useNavigate();

  const canEdit =
    user?.companyUser?.id_company === parseInt(companyId) &&
    user?.companyUser?.tipo_cuenta === "Administrador";

  const companySector = Array.isArray(company?.sector) ? company.sector[0] : company?.sector;

  return (
    <Card>
      <CardContent className="flex items-start gap-4 pt-6">
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-primary/10 text-2xl">
          {companyData?.sectores.find(
            (sector) => sector.label.toLowerCase() === companySector?.toLowerCase()
          )?.icon || "🏢"}
        </span>

        <div className="flex-1">
          <h2 className="text-xl font-semibold text-foreground">
            {company?.nombre_empresa
              ? company.nombre_empresa.toLowerCase().replace(/^\w/, (c) => c.toUpperCase())
              : "Nombre de la Empresa"}
          </h2>

          {company?.verificado_empresa && (
            <p className="text-sm font-medium text-primary">Empresa verificada</p>
          )}

          {company?.certificado && (
            <Badge className="mt-1 w-fit">Proveedor certificado</Badge>
          )}

          <p className="mt-1 text-sm text-muted-foreground">
            <strong className="text-foreground">Puntaje:</strong>{" "}
            {company?.puntaje?.promedio
              ? `${company.puntaje.promedio.toFixed(2)} ⭐ (${company.puntaje.num_reviews} reseñas)`
              : `0.0 ⭐ (0 reseñas)`}
          </p>

          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Página Web:</strong>{" "}
            {profile?.pagina_web ? (
              (() => {
                let url = profile.pagina_web.trim(); // ✅ Eliminar espacios en blanco

                // ✅ Agregar "https://" si no lo tiene
                if (!url.startsWith("http://") && !url.startsWith("https://")) {
                  url = `https://${url}`;
                }

                // ✅ Agregar "www." si no lo tiene y si es un dominio de segundo nivel
                try {
                  const urlObj = new URL(url);
                  if (!urlObj.hostname.startsWith("www.") && urlObj.hostname.split(".").length === 2) {
                    url = url.replace("//", "//www.");
                  }
                } catch (error) {
                  console.error("URL inválida:", profile.pagina_web);
                }

                return (
                  <a href={url} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                    {profile.pagina_web}
                  </a>
                );
              })()
            ) : (
              <i>Pendiente definir</i>
            )}
          </p>
        </div>

        {canEdit && (
          <button
            onClick={() => navigate(`/company-profile/${companyId}/admin/identificacion`)}
            className="text-muted-foreground hover:text-foreground"
            aria-label="Editar"
          >
            <Pencil className="h-4 w-4" />
          </button>
        )}
      </CardContent>
    </Card>
  );
};

export default CompanyProfileHeader;
